import { render, staticRenderFns } from "./brandInvestmentPopup.vue?vue&type=template&id=31f2e536&scoped=true&"
import script from "./brandInvestmentPopup.vue?vue&type=script&lang=js&"
export * from "./brandInvestmentPopup.vue?vue&type=script&lang=js&"
import style0 from "./brandInvestmentPopup.vue?vue&type=style&index=0&id=31f2e536&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f2e536",
  null
  
)

export default component.exports